import { useEffect, useState } from 'react';
import { useNetwork } from '@/lib/network/NetworkProvider';
import { WifiOff, Wifi } from 'lucide-react';

const BACK_ONLINE_MS = 2800;

export default function ConnectivityBanner() {
  const { isOnline, ready } = useNetwork();
  const [showBackOnline, setShowBackOnline] = useState(false);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    if (!ready) return;
    if (!isOnline) {
      setWasOffline(true);
      setShowBackOnline(false);
      return;
    }
    if (wasOffline) {
      setShowBackOnline(true);
      const timer = setTimeout(() => setShowBackOnline(false), BACK_ONLINE_MS);
      setWasOffline(false);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [isOnline, ready, wasOffline]);

  if (!ready) return null;

  if (showBackOnline) {
    return (
      <div
        data-testid="connectivity-back-online"
        className="fixed top-0 left-0 right-0 z-[100] px-4 py-2.5 bg-emerald-600/95 backdrop-blur-sm text-white shadow-md"
        style={{ paddingTop: 'max(8px, env(safe-area-inset-top))' }}
      >
        <div className="flex items-center justify-center gap-2 text-sm font-medium">
          <Wifi className="w-4 h-4" />
          <span>Back online</span>
        </div>
      </div>
    );
  }

  if (!isOnline) {
    return (
      <div
        data-testid="connectivity-offline-banner"
        className="fixed top-0 left-0 right-0 z-[100] px-4 py-2.5 bg-slate-800/95 backdrop-blur-sm text-white shadow-md"
        style={{ paddingTop: 'max(8px, env(safe-area-inset-top))' }}
      >
        <div className="flex items-center justify-center gap-2 text-sm font-medium">
          <WifiOff className="w-4 h-4 text-slate-300" />
          <span>You&apos;re offline</span>
        </div>
        <p className="text-center text-[11px] text-slate-300 mt-0.5">
          Showing last known info where available.
        </p>
      </div>
    );
  }

  return null;
}
